import { defineComponent as _defineComponent } from 'vue'
import {ref} from 'vue'
import { t } from '@/plugins/i18n';
import { useNewFloorStore } from '@/stores'


export default /*#__PURE__*/_defineComponent({
  __name: 'UploadFile',
  props: {
    stepIndex: null
  },
  setup(__props: any) {

const props = __props as {
  stepIndex: number
};



const loadingStatus = ref<'' | 'in-progress' | 'done'>('')
const newFloorStore = useNewFloorStore()

const uploadText = t('Drag and drop png or svg file')
const uploadTextLine2 = t('or')
const uploadButtonLabel = t('Browse files')
const acceptType = t('image/svg+xml, image/png')
const fileSizeUnits = ['Bytes', 'KB', 'MB']
const wrongTypeErrorMessage = t('Upload failed. Supported file types are png and svg.')
const uploadFileErrorMessage = t('Upload failed. Please try again.')

const onDone = (data: {
  formData: FormData,
  fileUrl: string,
  addedFile: File
}) => {
  loadingStatus.value = 'done'
  newFloorStore.$patch({uploadedFileFormData: data.formData, uploadedFileUrl: data.fileUrl, uploadedFile: data.addedFile})
  newFloorStore.setIsCompletedStep(props.stepIndex, true)
}

const onRemovedFile = function () {
  newFloorStore.setIsCompletedStep(props.stepIndex, false)
  newFloorStore.setNextCompletedStep(props.stepIndex, false)
  newFloorStore.$patch({
    uploadedFileFormData: undefined,
    uploadedFileUrl: '',
    uploadedFile: undefined,
  })
}


return { __sfc: true,props, loadingStatus, newFloorStore, uploadText, uploadTextLine2, uploadButtonLabel, acceptType, fileSizeUnits, wrongTypeErrorMessage, uploadFileErrorMessage, onDone, onRemovedFile, t }
}

})